import React from 'react'
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { CUTTLY_URL } from '../../../../Constants';
import { devConsolelog } from '../../../../Utility';
// import Box from '@material-ui/core/Box';
// import Loading from '../../../Commons/loading';

const HandleShareBookingLinkRedirection = () => {

    const { cuttlyId = '' } = useParams();
    devConsolelog('search params123', cuttlyId, window.location)

    useEffect(() => {

        if (!cuttlyId) return;

        let redirectionUrl = '';
        redirectionUrl = `https://${CUTTLY_URL}/${cuttlyId}`
        window.location.href = redirectionUrl;

    }, [cuttlyId])

    return (<></>
        // <Box display={'flex'} justifyContent={'center'} mt={'50%'}>
        //     <Loading isLoading={true}/>
        // </Box>
    )
}

export default HandleShareBookingLinkRedirection